export const BaseRoutes = {
  OPERATIONS: "/operations",
  TRANSACTIONS: "/transactions",
  ORDERS: "/orders",
  FEEDS: "/feeds",
  FEED_SUBMISSION_JOBS: "/feed_submission_jobs",
  FEED_SUBMISSIONS: "/feed_submissions",
  MF_PURCHASES: "/mf_purchases",
  MF_PURCHASE_PLANS: "/mf_purchase_plans",
  MF_REDEMPTIONS: "/mf_redemptions",
  MF_REDEMPTION_PLANS: "/mf_redemption_plans",
  MF_SWITCHES: "/mf_switches",
  MF_SWITCH_PLANS: "/mf_switch_plans",
  PAYMENTS: "/payments",
  PAYOUTS: "/payouts",
  ORDERFEED: "/orderfeed",
  RECON: "/recon",
  DEPOSIT_RECEIPTS: "/deposit_receipts",
  DEPOSIT_RECEIPT_ADJUSTMENTS: "/deposit_receipt_adjustments",
  RECON_ADJUSTMENTS: "/recon_adjustments",
  SETTLEMENT_INSTRUCTIONS: "/settlement_instructions",
  SETTLEMENT_REPORT_FILES: "/settlement_report_files",
  BANK_ACCOUNT_STATEMENTS: "/bank_account_statements",
  MANDATES: "/mandates",
  INVESTORS: "/investors",
  INVESTOR_PROFILES: "/investor_profiles",
  MF_INVESTMENT_ACCOUNTS: "/mf_investment_accounts",
  INVESTOR_PROFILE_NON_INDIVIDUALS: "/investor_profile_non_individuals",
  KYC_REQUESTS: "/kyc_requests",
  KYC_FORMS: "/kyc_forms",
  MF_FOLIOS: "/mf_folios",
  BANK_ACCOUNT_VERIFICATIONS: "/bank_account_verifications",
  DEVELOPERS: "/developers",
  MONITORING_ALERTS: "/developers/monitoring-alerts",
  EVENTS: "/events",
  FP_ACCOUNT: "/fp-account",
  SCHEDULED_QUERIES: "/scheduled_queries",
  NOTIFICATION_WEBHOOKS: "/notification_webhooks",
  CONFIGURATIONS: "/configurations",
  PARTNERS: "/partners",
  NETWORK_INTELLIGENCE: "/network_intelligence",
  KYC: "/kyc",
  METRICS: "/metrics",
  SUPPORT: "/support",
  VERIFICATIONS: "/verifications",
  PAN_VERIFICATIONS: "/pan_verifications",
  BANK_ACCOUNT_VERIFICATION: "/bank_account_verification",
} as const;
